import styled from 'styled-components';
import Card from '../../../../Card';

const StyledPolicies = styled(Card)`
  .ant-card-head {
    flex-direction: unset;
    padding: 24px;
  }
`;


export {
  StyledPolicies,
}
